import { BookOpen, FolderKanban, Info, Lightbulb, Puzzle, Rocket, Sparkles, Code2 } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardDescription, CardHeader, CardTitle } from '../../components/Common/Card';
import { Link } from 'react-router-dom';
import { PageLayout } from '../../components/Layout/PageLayout';

const DocumentationDashboard: React.FC = () => {
  const { t } = useTranslation();
  const sections = [
    {
      titleKey: 'documentation.dashboard.sections.introduction.title',
      descriptionKey: 'documentation.dashboard.sections.introduction.description',
      href: '/documentation/introduction',
      icon: Info,
    },
    {
      titleKey: 'documentation.dashboard.sections.workflow.title',
      descriptionKey: 'documentation.dashboard.sections.workflow.description',
      href: '/documentation/workflow',
      icon: Rocket,
    },
    {
      titleKey: 'documentation.dashboard.sections.audits.title',
      descriptionKey: 'documentation.dashboard.sections.audits.description',
      href: '/documentation/audits',
      icon: Puzzle,
    },
    {
      titleKey: 'documentation.dashboard.sections.useCases.title',
      descriptionKey: 'documentation.dashboard.sections.useCases.description',
      href: '/documentation/use-cases',
      icon: Lightbulb,
    },
    {
      titleKey: 'documentation.dashboard.sections.cadrages.title',
      descriptionKey: 'documentation.dashboard.sections.cadrages.description',
      href: '/documentation/cadrages',
      icon: Code2,
    },
    {
      titleKey: 'documentation.dashboard.sections.projects.title',
      descriptionKey: 'documentation.dashboard.sections.projects.description',
      href: '/documentation/projects',
      icon: FolderKanban,
    },
    {
      titleKey: 'documentation.dashboard.sections.aiFeatures.title',
      descriptionKey: 'documentation.dashboard.sections.aiFeatures.description',
      href: '/documentation/ai-features',
      icon: Sparkles,
    },
  ];

  return (
    <PageLayout
      icon={<BookOpen className="h-6 w-6" />}
      title={t('documentation.userGuidePrefix', 'User Guide') + ': ' + t('documentation.dashboard.title')}
      subtitle={t('documentation.dashboard.description')}
    >
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {sections.map((section) => (
          <Link key={section.href} to={section.href}>
            <Card className="h-full hover:bg-muted/50 transition-colors cursor-pointer border-2 hover:border-primary/50">
              <CardHeader>
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 rounded-lg bg-primary/10 text-primary">
                    <section.icon className="h-6 w-6" />
                  </div>
                  <CardTitle>{t(section.titleKey)}</CardTitle>
                </div>
                <CardDescription>{t(section.descriptionKey)}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </PageLayout>
  );
};

export default DocumentationDashboard;
